import { zafClient } from ".";

type FieldMap = Map<string, number>;

let cache: FieldMap | null = null;

export const resolveFields = async (): Promise<(name: string) => number> => {
  if (!cache) cache = await fetchFields();
  const map = cache;
  return (name: string) => {
    const id = map.get(name);
    if (id === undefined) throw new Error(`Campo Zendesk não encontrado: "${name}"`);
    return id;
  };
};

async function fetchFields(): Promise<FieldMap> {
  const map: FieldMap = new Map();
  let page = 1;

  while (true) {
    const res = (await zafClient.request({
      url: `/api/v2/ticket_fields.json?per_page=100&page=${page}`,
      type: "GET",
    })) as {
      ticket_fields: Array<{ id: number; title: string }>;
      next_page: string | null;
    };

    for (const field of res.ticket_fields) {
      map.set(field.title, field.id);
    }

    if (!res.next_page) break;
    page++;
  }

  return map;
}
